export class CardInfoFields {
  number: string;
  month: string;
  year: string;
  verification: string;

  constructor() {
    this.number = '';
    this.month = '';
    this.year = '';
    this.verification = '';
  }
}

export class CardPaymentMethod {
  email: string;
  card: {
    brand?: string;
    name: string;
    address_postal_code: string;
    address_line1: string;
    address_line2: string;
    address_state: string;
    address_city: string;
    address_country: string;
    number: string;
    month: string;
    year: string;
    verification: string;
    metadata?: object;
  }

  constructor(paymentMethodMetadata: any, cardInfo: CardInfoFields) {
    this.email = paymentMethodMetadata.email;
    this.card = {
      name: paymentMethodMetadata.name,
      address_postal_code: paymentMethodMetadata.address_postal_code,
      address_line1: paymentMethodMetadata.address_line1,
      address_line2: paymentMethodMetadata.address_line2,
      address_state: paymentMethodMetadata.address_state,
      address_country: paymentMethodMetadata.address_country,
      address_city: paymentMethodMetadata.address_city,
      metadata: paymentMethodMetadata.metadata,
      number: cardInfo.number,
      month: cardInfo.month,
      year: cardInfo.year,
      verification: cardInfo.verification
    };
  }
}
